import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { colorGrayLight4 } from 'styles/layout/colors';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import customerDashboardLinks from '../../customerDashboardLinks';
export const allLinks = item => item;
export const removeQuoteLink = ({
  path
}) => path !== '/quote/';
const CustomerDashboardLinksUI = t0 => {
  const $ = _c(4);
  const {
    showQuoteLink: t1
  } = t0;
  const showQuoteLink = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== showQuoteLink) {
    t2 = customerDashboardLinks.filter(showQuoteLink ? allLinks : removeQuoteLink).map(_temp);
    $[0] = showQuoteLink;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="m-[0-1rem] lg:grid lg:gap-6 lg:grid-cols-[1fr_1fr] lg:m-0">{t2}</div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
CustomerDashboardLinksUI.propTypes = {
  showQuoteLink: PropTypes.bool
};
export default CustomerDashboardLinksUI;
function _temp(t0) {
  const {
    label,
    path,
    description,
    icon: Icon
  } = t0;
  return <Link to={path} className={classNames("group/CustomerDashboardLinksUI__item", "items-center border border-solid border-gray-light6 flex pt-6 pr-6 pb-6 pl-4 relative no-underline max-[1023px]:border-l-0 max-[1023px]:border-r-0 max-[1023px]:border-t-0 max-[1023px]:pr-10 lg:rounded lg:px-8 lg:py-12", "first:max-[1023px]:border-t", "hover:!no-underline hover:bg-gray-light9 hover:cursor-pointer")} key={path}><Icon color={colorGrayLight4} className="mr-8 max-[1023px]:h-[38px] max-[1023px]:mr-4 max-[1023px]:w-[38px]" /><div className="flex-1"><div className="text-lg font-bold !text-gray flex justify-between lg:text-xl lg:font-bold lg:items-center lg:inline-flex lg:justify-start"><span className="lg:mr-3.5">{label}</span><span className="max-[1023px]:items-center max-[1023px]:bottom-0 max-[1023px]:flex max-[1023px]:justify-center max-[1023px]:px-6 max-[1023px]:py-0 max-[1023px]:absolute max-[1023px]:right-0 max-[1023px]:top-0 lg:hidden group-hover/CustomerDashboardLinksUI__item:lg:block"><IconArrowRightSimple width={7} height={12} /></span></div><div className="text-sm !text-gray-light2 max-[1023px]:text-xs">{description}</div></div></Link>;
}